import { BrandId, BrandProfile } from '../app/core/brand.model';
import { ARANCONTA_FOOTER_DEFAULTS, GOMEZ_FOOTER_DEFAULTS } from './footer-defaults';

export const DEFAULT_BRAND_ID: BrandId = 'gomez';

export const BRAND_PROFILES: BrandProfile[] = [
  {
    id: 'gomez',
    domains: ['localhost', '127.0.0.1', 'ov-ggm-test.sfe-soft.es'],
    productName: 'GGM Connect',
    companyName: 'Gomez Group Metering',
    logoPath: 'assets/img/logo-gomez.png',
    pageTitlePrefix: 'GGM Connect',
    portalDefaultDescription: 'Accede a tu Oficina Virtual GGM.',
    appOrigin: 'ggm-ov-login-web',
    footer: GOMEZ_FOOTER_DEFAULTS,
  },
  {
    id: 'aranconta',
    domains: ['ov-aran-test.sfe-soft.es'],
    productName: 'Aranconta Connect',
    companyName: 'Aranconta Metering',
    logoPath: 'assets/img/logo-aranconta.png',
    pageTitlePrefix: 'Aranconta',
    portalDefaultDescription: 'Accede a tu Oficina Virtual Aranconta.',
    appOrigin: 'ggm-ov-login-web',
    footer: ARANCONTA_FOOTER_DEFAULTS,
  },
];
